import React from 'react';
import { Modal } from 'antd';
import { HelpLoader } from 'mod/help/HelpLoader';

type IProps = {
    visible: boolean;
    setVisible?: any;
    onClose?: any;

}

const ReturnPolicyModal: React.FC<IProps> = (props) => {
    const {
        visible,
        setVisible,
        onClose,
    } = props

    return (
        <Modal
            width={'70%'}
            open={visible}
            footer={false}
            centered={true}
            onCancel={() => {
                if (onClose) {
                    onClose();
                }
                if (setVisible) {
                    setVisible(false);
                }
            }}
        >
            <HelpLoader code={'return-policy'}/>
        </Modal>
    )
}

export default React.memo(ReturnPolicyModal)
